import { getWishlist, getWishlistSummary, putInWishlist, removeFromWishlist } from '@/api/wishlist'

const wishlist = {
  namespaced: true,
  state: () => ({
    status: {
      items: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      summary: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    items: [],
    summary: {
      items: 0,
      points: 0,
    },
  }),
  getters: {
    // getWishlist: (state) => state.items,
    // getWishlistSummary: (state) => state.summary,
    // isWishlistLoaded: (state) => state.status === 'success',
    // isWishlistItemPut: (state) => state.status === 'success',
    // isWishlistItemRemoved: (state) => state.status === 'success'
  },
  actions: {
    fetchWishlist ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'items')
        commit('SET_ERROR_FALSE', 'items')
        getWishlist(0, 20)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'items')
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ITEMS', items)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'items')
            commit('SET_ERROR_TRUE', 'items')
            reject(err)
          })
      })
    },
    fetchWishlistSummary ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'summary')
        commit('SET_ERROR_FALSE', 'summary')
        getWishlistSummary()
          .then((summary) => {
            commit('SET_INITIALIZED_TRUE', 'summary')
            commit('SET_REFRESHING_FALSE', 'summary')
            commit('SET_SUMMARY', summary)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'summary')
            commit('SET_ERROR_TRUE', 'summary')
            reject(err)
          })
      })
    },
    addWishlistItem ({
      commit,
      dispatch
    }, data) {
      return new Promise((resolve, reject) => {
        putInWishlist(data.productVersionId, data.categoryID)
          .then(() => {
            resolve()
            dispatch('fetchWishlist')
            dispatch('fetchWishlistSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchWishlist')
            dispatch('fetchWishlistSummary')
          })
      })
    },
    removeWishlistItem ({
      commit,
      dispatch
    }, wishlistItemId) {
      return new Promise((resolve, reject) => {
        removeFromWishlist(wishlistItemId)
          .then(() => {
            resolve()
            dispatch('fetchWishlist')
            dispatch('fetchWishlistSummary')
          })
          .catch((err) => {
            reject(err)
            dispatch('fetchWishlist')
            dispatch('fetchWishlistSummary')
          })
      })
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false
    },
    SET_ITEMS: (state, payload) => {
      state.items = payload
    },
    SET_SUMMARY: (state, payload) => {
      state.summary.items = payload.items
      state.summary.points = payload.points
    },
  },
}

export default wishlist
